import { DateTime } from "luxon"

export function getCronTimeUtc(date) {
  let timeValue = date
    ? DateTime.fromJSDate(date).toUTC().toFormat("mm HH")
    : "0 0"

  return timeValue
}

export function getLocalTimeValue(time, timezone) {
  let newTime = DateTime.fromJSDate(time)

  if (timezone) {
    newTime = newTime.setZone(timezone, {
      keepLocalTime: true,
    })
  }

  return newTime
}
